import { SWReactIcons } from "@similarweb/icons";

import { PlainTooltip } from "@similarweb/ui-components";

import * as SC from "./styles";

type SeparatorItemSchema = {
    text: string;
    tooltipContent?: string;
    isTooltipVisible?: boolean;
    isVisible?: boolean;
};

export const SeparatorItem = ({ text, tooltipContent, isTooltipVisible = false, isVisible = true }: SeparatorItemSchema) => {
    if (!isVisible) {
        return null
    }

    return (
        <SC.ItemWrapper>
            <SC.ItemText>{text}</SC.ItemText>
            {
                isTooltipVisible ? <PlainTooltip tooltipContent={tooltipContent}>
                        <span>
                            <SWReactIcons
                                iconName="info"
                                size="xs"
                            />
                        </span>
                    </PlainTooltip> : null
            }
        </SC.ItemWrapper>
    );
}
